module.exports = __webpack_public_path__ + "img/green-square-table-12.77abbd23.png";